<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="id_puesto"
      class="tabulador-table"
      :items-per-page="-1"
      hide-default-footer
    >
      <!-- Puesto -->
      <template v-slot:[`item.nombre`]="{ item }">
        <div>{{ item.nombre }}</div>
      </template>

      <!-- Categoría A -->
      <template v-slot:[`item.categoria_a`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="cat-cell d-flex align-center" style="gap:8px" v-on="on" v-bind="attrs">
              <div class="w-100">
                <div class="tiny-row"><span class="tiny-label">SDI:</span><span class="tiny-value">{{ money(item.categoria_a.sdi) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 30d:</span><span class="tiny-value">{{ money(item.categoria_a.bruto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 15d:</span><span class="tiny-value">{{ money(item.categoria_a.bruto15) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 30d:</span><span class="tiny-value">{{ money(item.categoria_a.neto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 15d:</span><span class="tiny-value">{{ money(item.categoria_a.neto15) }}</span></div>
              </div>
              <v-icon small class="ml-1" @click.stop="openDialogEdit(item, 'categoria_a')">mdi-pencil</v-icon>
            </div>
          </template>
          <div class="text-body-2">
            <div v-if="item.categoria_a.lastEditedAt">
              <strong>Última edición:</strong><br>
              {{ formatDateTime(item.categoria_a.lastEditedAt) }}<br>
              <em>por {{ item.categoria_a.lastEditedBy }}</em>
            </div>
            <div v-else><em>Nunca editado</em></div>
          </div>
        </v-tooltip>
      </template>

      <!-- Categoría B -->
      <template v-slot:[`item.categoria_b`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="cat-cell d-flex align-center" style="gap:8px" v-on="on" v-bind="attrs">
              <div class="w-100">
                <div class="tiny-row"><span class="tiny-label">SDI:</span><span class="tiny-value">{{ money(item.categoria_b.sdi) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 30d:</span><span class="tiny-value">{{ money(item.categoria_b.bruto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 15d:</span><span class="tiny-value">{{ money(item.categoria_b.bruto15) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 30d:</span><span class="tiny-value">{{ money(item.categoria_b.neto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 15d:</span><span class="tiny-value">{{ money(item.categoria_b.neto15) }}</span></div>
              </div>
              <v-icon small class="ml-1" @click.stop="openDialogEdit(item, 'categoria_b')">mdi-pencil</v-icon>
            </div>
          </template>
          <div class="text-body-2">
            <div v-if="item.categoria_b.lastEditedAt">
              <strong>Última edición:</strong><br>
              {{ formatDateTime(item.categoria_b.lastEditedAt) }}<br>
              <em>por {{ item.categoria_b.lastEditedBy }}</em>
            </div>
            <div v-else><em>Nunca editado</em></div>
          </div>
        </v-tooltip>
      </template>

      <!-- Categoría C -->
      <template v-slot:[`item.categoria_c`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="cat-cell d-flex align-center" style="gap:8px" v-on="on" v-bind="attrs">
              <div class="w-100">
                <div class="tiny-row"><span class="tiny-label">SDI:</span><span class="tiny-value">{{ money(item.categoria_c.sdi) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 30d:</span><span class="tiny-value">{{ money(item.categoria_c.bruto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 15d:</span><span class="tiny-value">{{ money(item.categoria_c.bruto15) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 30d:</span><span class="tiny-value">{{ money(item.categoria_c.neto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 15d:</span><span class="tiny-value">{{ money(item.categoria_c.neto15) }}</span></div>
              </div>
              <v-icon small class="ml-1" @click.stop="openDialogEdit(item, 'categoria_c')">mdi-pencil</v-icon>
            </div>
          </template>
          <div class="text-body-2">
            <div v-if="item.categoria_c.lastEditedAt">
              <strong>Última edición:</strong><br>
              {{ formatDateTime(item.categoria_c.lastEditedAt) }}<br>
              <em>por {{ item.categoria_c.lastEditedBy }}</em>
            </div>
            <div v-else><em>Nunca editado</em></div>
          </div>
        </v-tooltip>
      </template>

      <!-- Categoría D -->
      <template v-slot:[`item.categoria_d`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="cat-cell d-flex align-center" style="gap:8px" v-on="on" v-bind="attrs">
              <div class="w-100">
                <div class="tiny-row"><span class="tiny-label">SDI:</span><span class="tiny-value">{{ money(item.categoria_d.sdi) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 30d:</span><span class="tiny-value">{{ money(item.categoria_d.bruto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Bruto 15d:</span><span class="tiny-value">{{ money(item.categoria_d.bruto15) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 30d:</span><span class="tiny-value">{{ money(item.categoria_d.neto30) }}</span></div>
                <div class="tiny-row"><span class="tiny-label">Neto 15d:</span><span class="tiny-value">{{ money(item.categoria_d.neto15) }}</span></div>
              </div>
              <v-icon small class="ml-1" @click.stop="openDialogEdit(item, 'categoria_d')">mdi-pencil</v-icon>
            </div>
          </template>
          <div class="text-body-2">
            <div v-if="item.categoria_d.lastEditedAt">
              <strong>Última edición:</strong><br>
              {{ formatDateTime(item.categoria_d.lastEditedAt) }}<br>
              <em>por {{ item.categoria_d.lastEditedBy }}</em>
            </div>
            <div v-else><em>Nunca editado</em></div>
          </div>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Diálogo Editar -->
    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-title class="pb-0">
          Editar sueldos — {{ edit.name }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model.number="edit.sdi" label="Sueldo Diario Integrado" type="number" min="0" step="0.01" outlined dense hide-details />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="edit.bruto30" label="Sueldo Bruto a 30 Días" type="number" min="0" step="0.01" outlined dense hide-details />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="edit.bruto15" label="Sueldo Bruto a 15 Días" type="number" min="0" step="0.01" outlined dense hide-details />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="edit.neto30" label="Sueldo Neto a 30 Días" type="number" min="0" step="0.01" outlined dense hide-details />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="edit.neto15" label="Sueldo Neto a 15 Días" type="number" min="0" step="0.01" outlined dense hide-details />
            </v-col>

            <!-- NUEVO: Editado por / Fecha -->
            <v-col cols="12">
              Última edición: {{ editMeta.lastEditedBy }} <em>por {{ formatDateTime(editMeta.lastEditedAtLocal) }}</em>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="closeDialog">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveEdit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    loading: false,
    items: [],
    headers: [
      { text: "Puesto", value: "nombre", align: "start", width: "34%" },
      { text: "Categoría A", value: "categoria_a", align: "center", width: "16%" },
      { text: "Categoría B", value: "categoria_b", align: "center", width: "16%" },
      { text: "Categoría C", value: "categoria_c", align: "center", width: "16%" },
      { text: "Categoría D", value: "categoria_d", align: "center", width: "16%" }
    ],
    currentUser: "Administrador (mock)",

    dialog: false,
    saving: false,

    edit:{ 
      name: "",
      sdi: 0,
      bruto30: 0,
      bruto15: 0,
      neto30: 0,
      neto15: 0 
    },
    editMeta: {
      lastEditedBy: null,
      lastEditedAt: null,
      lastEditedAtLocal: null, // para input datetime-local
    },
    defaultEdit:{ 
      name: "",
      sdi: 0,
      bruto30: 0,
      bruto15: 0,
      neto30: 0,
      neto15: 0 
    },

    editTarget: { index: -1, key: null },
  }),
  mounted(){
    this.getItems();
  },
  methods: {
    getItems(){
      this.loading = true;
      axios.get("/RecursosHumanos/ListarPuestos")
        .then(response => {
          this.items = [];
          response.data.forEach(x => {
            const salary_a = this.getRandomSalary();
            const salary_b = salary_a * this.getRandomFactor();
            const salary_c = salary_b * this.getRandomFactor();
            const salary_d = salary_c * this.getRandomFactor();

            this.items.push({
              id_puesto: x.id_puesto,
              nombre: x.nombre,
              // Si no hay editor, lo inventamos (mock)
              categoria_a: this.getCategoria(salary_a, true),
              categoria_b: this.getCategoria(salary_b, true),
              categoria_c: this.getCategoria(salary_c, true),
              categoria_d: this.getCategoria(salary_d, true)
            });
          });
        })
        .catch(console.log)
        .finally(() => { this.loading = false; });
    },

    getCategoria(b, withMockEditor = false){
      const b30 = Math.round(b);
      const sdi = +(b30 / 30).toFixed(2);
      const b15 = Math.round(b30 / 2);
      const n30 = Math.round(b30 * 0.83);
      const n15 = Math.round(b15 * 0.83);

      const lastEditedBy = withMockEditor ? this.getRandomEditor() : null;
      const lastEditedAt = withMockEditor ? this.getRandomPastISO() : null;

      return { sdi, bruto30: b30, bruto15: b15, neto30: n30, neto15: n15, lastEditedBy, lastEditedAt };
    },

    getRandomSalary() {
      const min = 8000, max = 20000;
      return Math.round(Math.random() * (max - min) + min);
    },
    getRandomFactor() {
      const min = 1.1, max = 1.5;
      return +(Math.random() * (max - min) + min).toFixed(2);
    },

    getRandomEditor(){
      const names = [
        "María Pérez", "Juan López", "C. Herrera", "A. García",
        "Luis Sánchez", "Karla Núñez", "I. Romero", "P. Ortega"
      ];
      return names[Math.floor(Math.random() * names.length)];
    },
    getRandomPastISO(daysBack = 90){
      const now = new Date();
      const past = new Date(now.getTime() - Math.random() * daysBack * 24 * 60 * 60 * 1000);
      return past.toISOString();
    },

    openDialogEdit(row, key){
      const idx = this.items.findIndex(it => it.id_puesto === row.id_puesto);
      const cat = this.items[idx][key];

      this.edit = Object.assign({}, this.defaultEdit, cat, { name: row.nombre });

      const by = cat.lastEditedBy || this.getRandomEditor(); // inventar si no hay
      const atISO = cat.lastEditedAt || this.getRandomPastISO(); // inventar si no hay
      this.editMeta = {
        lastEditedBy: by,
        lastEditedAt: atISO,
        lastEditedAtLocal: this.isoToLocalInput(atISO)
      };

      this.editTarget = { index: idx, key };
      this.dialog = true;
    },

    async saveEdit(){
      this.saving = true;
      try {
        const idx = this.editTarget.index;
        const key = this.editTarget.key;
        if (idx < 0 || !key) return;

        // Normaliza editor/fecha desde el diálogo
        const by = (this.editMeta.lastEditedBy && this.editMeta.lastEditedBy.trim())
          ? this.editMeta.lastEditedBy.trim()
          : this.getRandomEditor(); // inventar si quedó vacío

        const atISO = this.localInputToISO(this.editMeta.lastEditedAtLocal) || new Date().toISOString();

        const updated = {
          sdi: Number(this.edit.sdi) || 0,
          bruto30: Number(this.edit.bruto30) || 0,
          bruto15: Number(this.edit.bruto15) || 0,
          neto30: Number(this.edit.neto30) || 0,
          neto15: Number(this.edit.neto15) || 0,
          lastEditedBy: by,
          lastEditedAt: atISO
        };

        // Ajustes derivados si quieres consistencia automática
        if (!this.edit.sdi && updated.bruto30) updated.sdi = +(updated.bruto30 / 30).toFixed(2);
        if (!this.edit.bruto15 && updated.bruto30) updated.bruto15 = Math.round(updated.bruto30 / 2);
        if (!this.edit.neto30 && updated.bruto30) updated.neto30 = Math.round(updated.bruto30 * 0.83);
        if (!this.edit.neto15 && updated.bruto15) updated.neto15 = Math.round(updated.bruto15 * 0.83);

        this.$set(this.items[idx], key, Object.assign({}, this.items[idx][key], updated));
        this.closeDialog();
      } finally {
        this.saving = false;
      }
    },

    closeDialog(){
      this.edit = Object.assign({}, this.defaultEdit);
      this.editMeta = { lastEditedBy: null, lastEditedAt: null, lastEditedAtLocal: null };
      this.editTarget = { index: -1, key: null };
      this.dialog = false;
    },

    // Utils de formato
    money(v) {
      return v == null || isNaN(v)
        ? "—"
        : Number(v).toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
            maximumFractionDigits: 2
          });
    },
    formatDateTime(iso){
      try {
        const d = new Date(iso);
        return d.toLocaleString("es-MX", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
      } catch { return iso; }
    },
    isoToLocalInput(iso){
      // Convierte ISO a 'yyyy-MM-ddTHH:mm' para <input type="datetime-local">
      try {
        const d = new Date(iso);
        const pad = n => (n<10?'0':'') + n;
        const yyyy = d.getFullYear();
        const MM = pad(d.getMonth()+1);
        const dd = pad(d.getDate());
        const hh = pad(d.getHours());
        const mm = pad(d.getMinutes());
        return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
      } catch { return null; }
    },
    localInputToISO(localStr){
      // De 'yyyy-MM-ddTHH:mm' a ISO; si falla, retorna null
      if (!localStr) return null;
      try {
        const d = new Date(localStr);
        return d.toISOString();
      } catch { return null; }
    },
  },
}
</script>

<style scoped>
.tabulador-table .v-icon { cursor: pointer; }
.cursor-not-allowed { cursor: not-allowed; }

.cat-cell { min-width: 220px; }
.tiny-row { display: flex; align-items: baseline; line-height: 1.15; }
.tiny-label { font-size: 12px; color: rgba(0,0,0,.6); min-width: 70px; display: inline-block; }
.tiny-value { font-size: 12px; font-weight: 600; }
</style>
